import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Link,
  makeStyles,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse
} from '@material-ui/core';
import Label from '@hydra/common/components/Label';
import Icon from '@hydra/common/components/Icon';
import * as products from '../utils/products';
import Translate from '@hydra/common/components/i18n';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  schemaCell: {
    maxWidth: 0
  },
  schemaJson: {
    padding: theme.spacing(1),
    cursor: 'pointer',
    overflow: 'auto'
  },
  image: {
    maxWidth: 300,
    maxHeight: 300
  },
  section: {
    marginBottom: theme.spacing(2)
  }
}));

function PropertyTableCell ({ children }) {
  return <TableCell variant='head' align='right'>{children}</TableCell>;
}

function SchemaDialog (props) {
  const { onClose, open, schema } = props;
  const classes = useStyles();

  const name = products.getName(schema);
  const url = products.getUrl(schema);
  const imageUrl = products.getImageUrl(schema);

  const [schemaExpanded, setSchemaExpanded] = React.useState(false);

  return open && (
    <Dialog onClose={onClose} aria-labelledby='simple-dialog-title' open fullWidth>
      <DialogTitle disableTypography id='simple-dialog-title'>
        <Typography variant='h3'>
          <Translate content='crawler_product_details' />
        </Typography>
        <IconButton onClick={onClose} className={classes.closeButton}>
          <Icon type='cross' size='md' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table className={classes.table} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell align='right'>Property</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <PropertyTableCell>Name</PropertyTableCell>
                <TableCell>{name}</TableCell>
              </TableRow>
              <TableRow>
                <PropertyTableCell>Url</PropertyTableCell>
                <TableCell>{url}</TableCell>
              </TableRow>
              <TableRow>
                <PropertyTableCell>Image</PropertyTableCell>
                <TableCell><img className={classes.image} src={imageUrl} /></TableCell>
              </TableRow>
              <TableRow>
                <PropertyTableCell>Schema</PropertyTableCell>
                <TableCell className={classes.schemaCell}>
                  <Collapse in={schemaExpanded} collapsedHeight={100}>
                    <div
                      className={classes.schemaJson}
                      onClick={() => setSchemaExpanded(expanded => !expanded)}
                    >
                      <pre>{JSON.stringify(schema, null, 2)}</pre>
                    </div>
                  </Collapse>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}

export default function SchemaLabel ({ schema }) {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => setOpen(true);
  const classes = useStyles();

  return (
    <>
      <SchemaDialog schema={schema} open={open} onClose={() => setOpen(false)} />
      <Link className={classes.root} onClick={handleClick}>
        <Label noBackground>
          {products.getName(schema)}
        </Label>
      </Link>
    </>
  );
}
